import Localization from 'lib/localization';

export default {
  lxReadMore() {
    return Localization.get('bumblesite@love_stories.read_more');
  },
  lxA11ySocialLink(social_network: string) {
    return Localization.get('bumblesite@social-links.item.a11y.label', {
      social_network,
    });
  },
  get lxA11yOpensInNewWindow() {
    return Localization.get('mw@link.a11y.label.new-window');
  },
};
